import api from '@api'
import { setInsightsData } from './index.js'

export const getCreditWatchScoresQuery = bid => async (dispatch, getState) => {
  try {
    const res = await api.get(`/v1/businesses/${bid}/credit_watch_query/current`)
    await dispatch(setInsightsData({ detailHistory: res.data }))
    //return res.data
  } catch (error) {
    console.error(error)
  }
}

export default getCreditWatchScoresQuery
